/**
 * Pricing Constants - Single Source of Truth (Frontend)
 *
 * Centraliza todos los precios del sistema para evitar duplicación.
 * Cualquier cambio de precios debe hacerse ÚNICAMENTE en este archivo.
 *
 * Modelo de negocio: Servicios independientes (no jerárquicos)
 * - 1 usuario = 1 caso = 1 pago único
 *
 * Siguiendo ADR-016: Centralized Constants Pattern
 * Aplicando DRY principle de PATTERNS_FROM_BASKET_BASE.md
 */

// Pricing configuration - ÚNICA FUENTE DE VERDAD
export const PRICING = {
  OLVIDO: {
    id: 'olvido',
    name: 'Derecho al Olvido',
    price: 499,
    priceLabel: '499€',
    urlLimit: 5
  },
  OLVIDO_POSTMORTEM: {
    id: 'olvido_postmortem',
    name: 'Derecho al Olvido Post-Mortem',
    price: 699,
    priceLabel: '699€',
    urlLimit: 5
  },
  TESTAMENTO: {
    id: 'testamento',
    name: 'Testamento Digital',
    price: 599,
    priceLabel: '599€',
    urlLimit: 0
  }
}

// Helper: Obtener precio por tier id
export const getPriceByTier = (tier) => {
  const config = Object.values(PRICING).find(p => p.id === tier)
  return config?.price || 0
}

// Helper: Obtener precio formateado por tier id
export const getPriceLabelByTier = (tier) => {
  const config = Object.values(PRICING).find(p => p.id === tier)
  return config?.priceLabel || '0€'
}

// Helper: Obtener URL limit por tier id
export const getUrlLimitByTier = (tier) => {
  const config = Object.values(PRICING).find(p => p.id === tier)
  return config?.urlLimit || 0
}

// Precios por tier (para uso directo en mapeos)
export const TIER_PRICES = {
  [PRICING.OLVIDO.id]: PRICING.OLVIDO.price,
  [PRICING.OLVIDO_POSTMORTEM.id]: PRICING.OLVIDO_POSTMORTEM.price,
  [PRICING.TESTAMENTO.id]: PRICING.TESTAMENTO.price
}

// Labels de precios por tier
export const TIER_PRICE_LABELS = {
  [PRICING.OLVIDO.id]: PRICING.OLVIDO.priceLabel,
  [PRICING.OLVIDO_POSTMORTEM.id]: PRICING.OLVIDO_POSTMORTEM.priceLabel,
  [PRICING.TESTAMENTO.id]: PRICING.TESTAMENTO.priceLabel
}

export default {
  PRICING,
  getPriceByTier,
  getPriceLabelByTier,
  getUrlLimitByTier,
  TIER_PRICES,
  TIER_PRICE_LABELS
}
